{
  "en": {
    "areas": {
      "kitchen": "Kitchen",
      "patio": "Patio",
      "balcony": "Balcony",
      "commonBathroom": "Shared bathroom",
      "elevator": "Elevator",
      "commonAirConditioner": "Shared air conditioner",
      "commonFan": "Shared fan"
    },
    "tabs": {
      "tab1": "Overview",
      "tab2": "Tenants",
      "tab3": "Inventories",
      "tab4": "Units",
      "tab5": "Expenses",
      "tab6": "Incidents",
      "tab7": "Contracts",
      "tab8": "Signature",
      "tab9": "Notes",
      "tab10": "Settings"
    },
    "expensesList": {
      "title": "Property Expenses",
      "createButton": "Create Expense",
      "filters": {
        "type": "Expense Type",
        "order": "Order"
      },
      "tableHeader": {
        "category": "Category",
        "title": "Title",
        "description": "Description",
        "date": "Date",
        "amount": "Amount",
        "status": "Status"
      },
      "noData": "No expenses found for this property",
      "clear": "Clear filters"
    },
    "inventoriesList": {
      "title": "Property Inventories",
      "createButton": "New Inventory",
      "tableHeader": {
        "description": "Description",
        "itemsCount": "Items",
        "type": "Type",
        "untitledInventory": "Inspection without notes"
      },
      "stats": {
        "saved": "Saved inspections",
        "initial": "Initial",
        "final": "Final / Return"
      },
      "typeLabels": {
        "initial": "Delivery (Initial)",
        "final": "Received (Final)"
      },
      "pendingBadge": "Pending",
      "dropdownMenu": {
        "details": "Details",
        "edit": "Edit",
        "downloadPdf": "Download PDF"
      },
      "noData": "No inventories found for this property"
    },
    "overview": {
      "title": "Propertie Details",
      "id": "Property ID:",
      "rentMode": "Rent Mode: ",
      "addContractButton": "Add Contract",
      "minicards": {
        "card1": "Contracts",
        "card2": "Incidence",
        "card3": "Canceled",
        "card4": "Ocupancy"
      },
      "sectionsTitles": {
        "section1": "Status",
        "section2": "Common Areas",
        "section3": "Collected Amounts",
        "section4": "Photos",
        "section5": "Contacts",
        "section6": "Insurances"
      },
      "pictureGallerySection": {
        "title": "Property Images",
        "button2": "View Gallery",
        "noImages": "No images available"
      },
      "insurancesTable": {
        "noData": "No insurances registered yet, you can create some.",
        "headers": {
          "company": "Company",
          "phone": "Phone",
          "policyNumber": "Policy Number",
          "holder": "Holder",
          "holderDocument": "Holder Document",
          "broker": "Broker",
          "brokerPhone": "Broker Phone",
          "brokerEmail": "Broker Email",
          "policyPlan": "Policy Plan",
          "policyExpirationDate": "Expiration Date"
        }
      },
      "buttons": {
        "addContact": "Add Contact",
        "addInsurance": "Add Insurance"
      }
    },
    "unityDetail": {
      "noData": "No Unity has been created yet.",
      "tableHeader": {
        "name": "Name",
        "bedSize": "Bed Size",
        "bathroom": "Private Bath",
        "fan": "Fan",
        "airConditioner": "Air Cond...",
        "currentStatus": "Current Status"
      },
      "deleteConfirmation": {
        "title": "Unity deleted",
        "description": "has beeen deleted successfully"
      },
      "dropdownMenu": {
        "deatils": "Details",
        "edit": "Edit",
        "delete": "Delete"
      },
      "button": "Add Unity"
    },
    "tenantsList": {
      "title": "Property Tenants",
      "noData": "No Tenant has been created yet.",
      "tableHeader": {
        "unity": "Unity",
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "contractStatus": "Contract Status"
      },
      "dropdownMenu": {
        "details": "Details",
        "edit": "Contract Detail",
        "delete": "Delete"
      }
    },
    "incidentsList": {
      "noData": {
        "table": "Any Incident has been created yet",
        "unity": "No Unity associated"
      },
      "tableHeader": {
        "column1": "Room",
        "column2": "Incident Type",
        "column3": "Priority",
        "column4": "Category",
        "column5": "Finish",
        "column6": "Status"
      },
      "addButton": "Create Incident",
      "rowButton": "Details"
    },
    "contractsList": {
      "title": "Property Contracts",
      "noData": "No contracts have been created yet.",
      "addContractButton": "Add Contract",
      "tableHeader": {
        "column1": "Tenant",
        "column2": "Start Date",
        "column3": "Finish Date",
        "column4": "Rent Amount",
        "column5": "Status"
      },
      "rowButton": "Details"
    },
    "notesList": {
      "title": "Property Notes",
      "noData": "No notes have been created yet.",
      "input": {
        "label": "Write a note",
        "placeholder": "Enter your note",
        "availableChars": "available",
        "submitButton": "Submit"
      }
    },
    "tenants": {}
  },
  "es": {
    "areas": {
      "kitchen": "Cocina",
      "patio": "Patio",
      "balcony": "Balcón",
      "commonBathroom": "Baño compartido",
      "elevator": "Ascensor",
      "commonAirConditioner": "Aire acondicionado común",
      "commonFan": "Ventilación común"
    },
    "tabs": {
      "tab1": "Resumen",
      "tab2": "Inquilinos",
      "tab3": "Inventarios",
      "tab4": "Unidades",
      "tab5": "Gastos",
      "tab6": "Incidentes",
      "tab7": "Contratos",
      "tab8": "Firma",
      "tab9": "Notas",
      "tab10": "Configuración"
    },
    "expensesList": {
      "title": "Gastos de la propiedad",
      "createButton": "Crear Gasto",
      "filters": {
        "type": "Tipo de gasto",
        "order": "Orden"
      },
      "tableHeader": {
        "category": "Categoría",
        "title": "Título",
        "description": "Descripción",
        "date": "Fecha",
        "amount": "Monto",
        "status": "Estado"
      },
      "noData": "No hay gastos registrados para esta propiedad",
      "clear": "Limpiar filtros"
    },
    "inventoriesList": {
      "title": "Inventarios de la propiedad",
      "createButton": "Nuevo Inventario",
      "tableHeader": {
        "description": "Descripción / notas",
        "itemsCount": "Cantidad de ítems",
        "type": "Tipo",
        "untitledInventory": "Inspección sin notas"
      },
      "stats": {
        "saved": "Inspecciones guardadas",
        "initial": "Iniciales",
        "final": "Finales / Retorno"
      },
      "typeLabels": {
        "initial": "Entrega (Inicial)",
        "final": "Recibida (Final)"
      },
      "pendingBadge": "Pendiente",
      "dropdownMenu": {
        "details": "Detalles",
        "edit": "Editar",
        "downloadPdf": "Descargar PDF"
      },
      "noData": "No hay inventarios registrados para esta propiedad"
    },
    "overview": {
      "title": "Detalles de la Propiedad",
      "subtitle": "¿Qué quieres hacer?",
      "id": "ID de la Propiedad:",
      "rentMode": "Modo de Alquiler:",
      "addContractButton": "Agregar Contrato",
      "minicards": {
        "card1": "Contratos",
        "card2": "Incidencias",
        "card3": "Cancelados",
        "card4": "Ocupación"
      },
      "sectionsTitles": {
        "section1": "Estado",
        "section2": "Áreas Comunes",
        "section3": "Montos Recolectados",
        "section4": "Fotos",
        "section5": "Contactos",
        "section6": "Pólizas de Seguro"
      },
      "pictureGallerySection": {
        "title": "Imágenes de la Propiedad",
        "button2": "Ver Galería",
        "noImages": "No hay imágenes disponibles"
      },
      "insurancesTable": {
        "noData": "No hay pólizas registradas aún, puede crear algunas.",
        "headers": {
          "company": "Compañía",
          "phone": "Teléfono",
          "policyNumber": "Nº de póliza",
          "holder": "Titular",
          "holderDocument": "Doc. titular",
          "broker": "Corredor",
          "brokerPhone": "Tel. corredor",
          "brokerEmail": "Email corredor",
          "policyPlan": "Plan de póliza",
          "policyExpirationDate": "Vencimiento"
        }
      },
      "buttons": {
        "addContact": "Agregar Contacto",
        "addInsurance": "Agregar Póliza"
      }
    },
    "unityDetail": {
      "noData": "No ha sido creada alguna Unidad aún",
      "tableHeader": {
        "name": "Nombre",
        "bedSize": "Cama",
        "bathroom": "Baño Privado",
        "fan": "Ventilador",
        "airConditioner": "Aire Acond...",
        "currentStatus": "Estado Actual"
      },
      "deleteConfirmation": {
        "title": "Unidad Eliminda",
        "description": "Ha sido eliminada con éxito"
      },
      "dropdownMenu": {
        "deatils": "Detalles",
        "edit": "Editar",
        "delete": "Delete"
      },
      "button": "Agregar Unidad"
    },
    "tenantsList": {
      "title": "Inquilinos de la Propiedad",
      "noData": "No ha sido creado algún inquilino aún.",
      "tableHeader": {
        "unity": "Unidad",
        "name": "Nombre",
        "email": "Correo",
        "phone": "Teléfono",
        "contractStatus": "Estado de Contrato"
      },
      "dropdownMenu": {
        "details": "Detalles",
        "edit": "Detalles del Contrato",
        "delete": "Eliminar"
      }
    },
    "incidentsList": {
      "noData": {
        "table": "No ha sido creado algún incidente aún",
        "unity": "No hay unidades asociadas"
      },
      "tableHeader": {
        "column1": "Unidad",
        "column2": "Tipo",
        "column3": "Prioridad",
        "column4": "Categoría",
        "column5": "Final",
        "column6": "Estado"
      },
      "addButton": "Crear Incidente",
      "rowButton": "Detalles"
    },
    "contractsList": {
      "title": "Contratos de la propiedad",
      "noData": "No se ha creado algún contrato aún.",
      "addContractButton": "Agregar Contrato",
      "tableHeader": {
        "column1": "Inquilino",
        "column2": "Inicio",
        "column3": "Fin",
        "column4": "Monto",
        "column5": "Estado"
      },
      "rowButton": "Details"
    },
    "notesList": {
      "title": "Notas de la Propiedad",
      "noData": "No se ha creado alguna nota aún.",
      "input": {
        "label": "Escribir una nota",
        "placeholder": "Ingresa tu nota",
        "availableChars": "disponibles",
        "submitButton": "Enviar"
      }
    },
    "tenants": {}
  }
}